module.exports = __webpack_public_path__ + "img/battery_undefined.a19c6581.svg";